export default __webpack_public_path__ + "static/media/1328.f8df1aa5.png";